import { render, staticRenderFns } from "./ComplianceWorstPerformingElements.vue?vue&type=template&id=642c9b6c&"
import script from "./ComplianceWorstPerformingElements.vue?vue&type=script&lang=ts&"
export * from "./ComplianceWorstPerformingElements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports